// Frontend mappings for the 3 ecosystem entity kinds.
export const ECOSYSTEM_KINDS = [
  {
    kind: "vendor",
    path: "vendors",
    labelEn: "Vendors",
    labelFr: "Éditeurs",
    overlineEn: "Software vendor",
    overlineFr: "Éditeur logiciel",
    descEn: "Software vendors building AI-native or AI-enhanced planning, execution and decision platforms.",
    descFr: "Éditeurs de logiciels qui construisent des plateformes IA-native ou enrichies d'IA pour la planification, l'exécution et la décision.",
  },
  {
    kind: "service_provider",
    path: "service-providers",
    labelEn: "Service Providers",
    labelFr: "Cabinets",
    overlineEn: "Service provider",
    overlineFr: "Cabinet",
    descEn: "Consultancies and service providers implementing Supply Chain AI on the field.",
    descFr: "Cabinets de conseil et prestataires qui déploient l'IA en Operations sur le terrain.",
  },
  {
    kind: "expert",
    path: "experts",
    labelEn: "Experts",
    labelFr: "Experts",
    overlineEn: "Expert",
    overlineFr: "Expert",
    descEn: "Independent experts, thought leaders and contributors shaping the AI-in-Operations conversation.",
    descFr: "Experts indépendants, leaders d'opinion et contributeurs qui font avancer la conversation IA-Operations.",
  },
];

export const kindByPath = (p) => ECOSYSTEM_KINDS.find((k) => k.path === p);
export const kindByKey = (k) => ECOSYSTEM_KINDS.find((x) => x.kind === k);

export const pathFromKind = (kind) => (kindByKey(kind)?.path) || "vendors";
